module.exports = __webpack_public_path__ + "img/about-icon-1.647fa9f2.svg";